import { FC } from "react";
import Filter from "shared/components/Filter";
import {
  StyledContainer,
  StyledFiltersContainer,
  StyledSearchField,
} from "./styled";
import { useCustomerTicketsPage } from "modules/customerTickets/pages/CustomerTickets/context";

const PageFilterBar: FC = () => {
  const { searchData, filtersData } = useCustomerTicketsPage();

  return (
    <StyledContainer>
      <StyledFiltersContainer>
        {filtersData.map(({ title, ...props }) => (
          <Filter key={title} title={title} isSmallButton {...props} />
        ))}
      </StyledFiltersContainer>
      <StyledSearchField placeholder="Search" {...searchData} />
    </StyledContainer>
  );
};

export default PageFilterBar;
